import '@fontsource/libre-baskerville/700.css';
import '@fontsource/libre-baskerville/400-italic.css';
import '@fontsource-variable/geist';
import './styles/app.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Admin } from './admin/Admin';
import { App } from './app/App';

const root = createRoot(document.getElementById('root')!);
const isAdmin = window.location.pathname === '/admin' || window.location.pathname.startsWith('/admin/');
root.render(<StrictMode>{isAdmin ? <Admin /> : <App />}</StrictMode>);
